import React from 'react'
import { useTranslation } from 'react-i18next'
import { KibStandaloneLink } from '@chewy/kib-menus-react'

import '@chewy/kib-menus-styles/dist/styles/kib-standalone-link.css'
import styles from './PaymentMethodSection.module.scss'

const CareCreditsLink = () => {
  const { t } = useTranslation(['Dialogs'])

  return (
    <div className={styles.fieldContainer}>
      <div className={styles.careCreditsLinkContainer}>
        <KibStandaloneLink
          className={styles.careCreditsLink}
          href="https://www.carecreditprovidercenter.com/portal/home"
          linkType="external"
          size="small"
          target="_blank"
        >
          {t('Dialogs:ADD_PAYMENT_DIALOG_V2.VIEW_CARECREDIT_TRANSACTION')}
        </KibStandaloneLink>
      </div>
    </div>
  )
}

export default CareCreditsLink
